import { render, staticRenderFns } from "./FoodConsumptionPanel.vue?vue&type=template&id=76d72b1a&scoped=true&lang=html&"
import script from "./FoodConsumptionPanel.vue?vue&type=script&lang=js&"
export * from "./FoodConsumptionPanel.vue?vue&type=script&lang=js&"
import style0 from "./FoodConsumptionPanel.vue?vue&type=style&index=0&id=76d72b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d72b1a",
  null
  
)

export default component.exports